import { Link } from "react-router-dom";
import { FiCheckSquare, FiTarget } from "react-icons/fi";

// [NEW] The two kinds of items on an appraisal, in the words the business uses:
//   KRA  = the daily tasks an associate carries out (measured by KPIs).
//   Goal = a target the employee sets for this cycle; the manager approves it (PM-17).
const TEXT = {
  employee: {
    kra: "The daily tasks you carry out in your role. You add them under My KRA & KPI, your manager approves them, and KPIs measure them.",
    goal: "Targets you set for this cycle, each with a target, due date and weight. Your manager approves them.",
    kraLink: "/my-kra-kpi",
    goalLink: "/my-goals",
  },
  manager: {
    kra: "The daily tasks your associates carry out. They add them; you approve, edit or return them under KRA & KPI approvals.",
    goal: "Targets each team member sets for this cycle. You approve them or request changes under Goal approvals.",
    kraLink: "/team/kra-kpi-proposals",
    goalLink: "/team/goal-approvals",
  },
  hr: {
    kra: "The daily tasks an associate carries out, added by the employee and measured by KPIs. HR reviews and corrects them.",
    goal: "Targets employees set for the cycle, approved by their manager. HR reviews and corrects them.",
    kraLink: "/hr/kra-kpi",
    goalLink: "/hr/review",
  },
};

export default function KraGoalExplainer({ view = "employee", compact = false }) {
  const t = TEXT[view] || TEXT.employee;
  return (
    <div className={`kra-goal-explainer ${compact ? "is-compact" : ""}`} aria-label="KRA and goal explained">
      <div className="kra-goal-explainer-item">
        <FiCheckSquare aria-hidden="true" />
        <div>
          <strong>KRA = daily tasks</strong>
          <p className="muted">{t.kra} {!compact && <Link to={t.kraLink}>Open</Link>}</p>
        </div>
      </div>
      <div className="kra-goal-explainer-item">
        <FiTarget aria-hidden="true" />
        <div>
          <strong>Goals = set by the employee</strong>
          <p className="muted">{t.goal} {!compact && <Link to={t.goalLink}>Open</Link>}</p>
        </div>
      </div>
    </div>
  );
}
